<template>
    <div class="table-responsive">
        <el-table
            :data="data"
            class="el-table-css"
            style="width: 100%"
            :row-class-name="getRowClass"
        >
            <el-table-column prop="subrogationNumber" label="Subroqasiya №" width="250">
                <template #default="scope">
                    <a href="javascript:void(0)" style="color: #409eff; text-decoration: underline;"
                        @click="openSubrogation(scope.row.subrogationId)">
                        {{ scope.row.subrogationNumber }}
                    </a>
                </template>
            </el-table-column>
            <el-table-column prop="category" label="Kateqoriya" width="250"/>
            <el-table-column label="Tarix" width="260">
                <template #default="scope">
                    {{ formatDateTime(scope.row.date) }}
                </template>
            </el-table-column>
            <el-table-column prop="description" label="Təsvir" width="350"/>
            <el-table-column prop="stageLabel" label="Mərhələ" width="250"/>
            <el-table-column prop="responsibleName" label="Məsul şəxs"/>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        data: { type: Array },
        pagination: {
            type: Object,
            default: () => ({
                page: 1,
                pageSize: 30,
                total: 0
            })
        }
    },
    methods: {
        formatDateTime(date) {
            if (!date) return "";
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            const hour = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            return `${day}.${month}.${year} ${hour}:${min}`;
        },
        openSubrogation(id) {
            const route = this.$router.resolve({
                name: "Subroqasiya - Məlumat",
                params: { id }
            });
            window.open(route.href, "_blank");
        },
        getRowClass({ row }) {
            switch (row.category) {
                case "Təqvim":
                    return "calendar-row";
                case "Ödəniş":
                    return "payment-row";
                case "İclaslar":
                    return "hearing-row";
                default:
                    return "";
            }
        }
    }
};
</script>

<style scoped>
:deep(.calendar-row) {
    background-color: rgba(227, 244, 253, 0.4) !important;
}
:deep(.payment-row) {
    background-color: rgba(255, 248, 225, 0.4) !important;
}
:deep(.hearing-row) {
    background-color: rgba(255, 227, 227, 0.5) !important;
}

</style>
